.topbar {
  display: flex;

  width: 100%;
  height: 5rem;
  padding-inline: 3rem;

  justify-content: center;

  background-color: #1a0b2e;
  position: fixed;
  z-index: 1000;

  #container {
    display: flex;
    flex-direction: row;

    height: auto;
    width: 55rem;

    text-align: center;
    align-items: center;
    justify-content: space-between;
    gap: 10.5rem;

    font-family: Inter, Arial;
    font-style: normal;
    font-weight: 600;
    font-size: 1.5rem;
    letter-spacing: 0.02em;
  }

  svg {
    max-height: 2.438rem;
  }

  ul {
    display: flex;
    flex-direction: row;

    justify-content: space-between;
    align-items: center;

    list-style: none;

    width: 40vw;
    max-width: 32.438rem;

    li {
      a {
        color: #fff;
        text-decoration: none;
        cursor: pointer;
      }
    }
  }
}
